<template>
<div class="modal inmodal fade" id="edit-payment-type-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">{{__("close")}}</span></button>
                        <h3>{{__("edit_payment_type")}}</h3>
                     </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                  <form id="edit-payment-form" :action=route method="POST">
                                    <input id="modal-edit-csrf-token" type="hidden" name="_token" value="">
                                    <input type="hidden" name="_method" value="PATCH">
                                    <input type="hidden" name="payment_type_id" :value="currentPaymentTypeID">
                                    <input type="hidden" name="default_language_name" :value="defaultLanguage">
                                        <label><strong>{{__("payment_type_name")}}</strong></label>
                                            <div class="input-group m-b-xs">
                                                <select class="form-control disabled-select" style="max-width:60px" disabled>
                                                    <option :value="defaultLanguage" selected>{{defaultLanguage.toUpperCase()}}</option>
                                                </select>
                                                <input type="text" max="30" :value="namesForDefaultLanguage[currentPaymentTypeID]"  required name="name_in_default_language" class="form-control">
                                            </div>
                                        <div v-if="currentPaymentTypeID > 0">
                                          <div v-for="(name, languageName) in availableNames[currentPaymentTypeID]['name']"  class="input-group m-b-xs">
                                              <select class="form-control disabled-select available-translations-list" name="language[]" style="max-width:60px;" >
                                                  <option :value="languageName">{{languageName.toUpperCase()}}</option>
                                              </select>
                                              <input type="text" max="30" name="translation[]" :value="name" class="form-control">
                                          </div>
                                        </div>
                                        <div v-for="translationNumber  in addedTranslationsNumber" :key="translationNumber" class="input-group m-b-xs">
                                            <select v-model="currentlyChosenLanguage[currentPaymentTypeID][translationNumber]" class="form-control disabled-select available-translations-list" name="language[]" style="max-width:60px;" >
                                                <option v-for="(language,index) in languagesAvailableForTranslationNumber[currentPaymentTypeID][translationNumber]" :key="language" :value=language>{{language.toUpperCase()}}</option>
                                            </select>
                                            <input type="text" max="30" name="translation[]" class="form-control">
                                        </div>
                                        <button v-on:click="addTranslation" type="button" class="btn btn-primary add-translation-button">{{__("add_new_translation")}}</button>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-white" data-dismiss="modal">{{__("cancel")}}</button>
                            <button type="submit" form="edit-payment-form"  class="btn btn-primary">{{__("save")}}</button>
                        </div>
                </div>
            </div>
        </div>
</template>

<script>

// import { ModalInformationBus } from '../document-settings.js';

export default {
        name: 'modal-edit-payment-type',
        props: ['defaultLanguage', 'existingNames','languagesExceptDefaultJson', 'route'],
        data: function() {
            return {
              availableNames : [],
              currentPaymentTypeID : 0,
              namesForDefaultLanguage : {},
              availableLanguages : {},
              languagesAvailableForTranslationNumber : {},
              languagesExceptDefault : [],
              currentlyChosenLanguage : {},
              addedTranslationsNumber : 0,
            };
        },

        methods: {
            addTranslation()
            {
                if(this.addedTranslationsNumber < this.availableLanguages[this.currentPaymentTypeID].length)
                {
                    const lastChosenLanguage = this.currentlyChosenLanguage[this.currentPaymentTypeID][this.addedTranslationsNumber];

                    this.availableLanguages[this.currentPaymentTypeID] = this.availableLanguages[this.currentPaymentTypeID].filter(function(value){
                         return value != lastChosenLanguage;
                    });

                     this.languagesAvailableForTranslationNumber[this.currentPaymentTypeID][this.addedTranslationsNumber] = [lastChosenLanguage];

                    this.languagesAvailableForTranslationNumber[this.currentPaymentTypeID][this.addedTranslationsNumber + 1] = this.availableLanguages[this.currentPaymentTypeID];
                    this.currentlyChosenLanguage[this.currentPaymentTypeID][this.addedTranslationsNumber + 1] = this.availableLanguages[this.currentPaymentTypeID][0];
                    ++this.addedTranslationsNumber;
                }
            },

            reset : function() {
              this.availableNames = JSON.parse(this.existingNames);
              for(let paymentTypeID in this.availableNames)
               {
                 this.namesForDefaultLanguage[paymentTypeID] = this.availableNames[paymentTypeID]['name'][this.defaultLanguage];
                 delete this.availableNames[paymentTypeID]['name'][this.defaultLanguage];
                 this.availableLanguages[paymentTypeID] = this.languagesExceptDefault.filter(value => this.availableNames[paymentTypeID]['name'][value] == undefined);
                 this.currentlyChosenLanguage[paymentTypeID] = {};
                 this.languagesAvailableForTranslationNumber[paymentTypeID] = [];
               }
               this.addedTranslationsNumber = 0;
             },
        },

        mounted: function() {
           this.availableNames = JSON.parse(this.existingNames);
           this.languagesExceptDefault = JSON.parse(this.languagesExceptDefaultJson);
           const csrfTokenValue = $('meta[name="csrf-token"]').attr('content');
           $("#modal-edit-csrf-token").val(csrfTokenValue);
        },

        events: {
            displayEditModal(paymentTypeID) {
                this.currentPaymentTypeID = paymentTypeID;
                this.reset();
            }
        }
    }
</script>
